<div class="contact-container">
  <h2>Contact Us</h2>
  <app-form-row-split>
    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Interested in:'">
        </app-label>
        <app-select-box
            [itemList]="interestList"
            [multiple]="false"
            [hintText]="'Please select option'"
            [control]="interestControl"
            [required]="true"
            [selected]="selectedInterest"
            (valueChange)="onInterestSelect($event)">
        </app-select-box>
    </app-form-row>
  </app-form-row-split>
  <app-form-row-split>
    <app-form-row>
      <app-label
          ngProjectAs="name"
          [text]="'Name'">
      </app-label>
      <app-textbox
          [placeholder]="'Name'"
          [control]="personName">
      </app-textbox>
    </app-form-row>
  </app-form-row-split>
  <app-form-row-split>
      <app-form-row>
          <app-label
              ngProjectAs="name"
              [text]="'Email'">
          </app-label>
          <app-textbox
              [placeholder]="'Email'"
              [control]="email"
              [maxLength]="320"
              [showHint]="false">
          </app-textbox>
      </app-form-row>
      <app-form-row>
          <app-label
              ngProjectAs="name"
              [text]="'Contact Number'">
          </app-label>
          <app-textbox
              [placeholder]="'Contact Number'"
              [maxLength]="10"
              [control]="contact"
              [showHint]="true">
          </app-textbox>
      </app-form-row>
  </app-form-row-split>
  <app-form-row-split>
    <app-form-row>
      <app-label
          ngProjectAs="name"
          [text]="'Message'">
      </app-label>
      <app-textbox
          [control]="message"
          [maxLength]="500"
          [multiLine]="true"
          [showHint]="false">
      </app-textbox>
    </app-form-row>
  </app-form-row-split>
  <app-button [button]="saveAccountButton">
  </app-button>
</div>

<ng-template #errorMsg>
  <app-label
    [text]="'Error while submitting the details, Please try after some time.'">
  </app-label>
</ng-template>

<ng-template #successMsgTitle>
  <app-label
    [text]="'Success'">
  </app-label>
</ng-template>
<ng-template #successMsg>
  <div class="msg-container">
    <app-label
      [text]="'Details submitted successfully!'">
    </app-label>
  </div>
</ng-template>